/* eslint-disable sort-keys */

const colors = {
  accent: '#dc0d16',
  accentHover: '#b00a12',
  accentSoft: 'rgba(220, 13, 22, 0.08)',
  background: '#f3f4f7',
  backgroundDark: '#22272e',
  black: '#000000',
  border: '#efeff4',
  borderDarker: '#d7d7df',
  borderSubtle: '#e6e8ec',
  buttonDark: '#030303',
  buttonDarkDisabledBackground: '#f2f2f2',
  buttonDarkDisabledText: '#909090',
  buttonDarkHover: '#272727',
  primary: '#0f1419',
  secondary: '#536471',
  white: '#ffffff',
  whiteHover: '#f3f4f6',
  whiteSmoke: '#ebebeb',
  nav: {
    active: 'rgba(177, 186, 196, 0.14)',
    background: '#0d1117',
    border: 'rgba(240, 246, 252, 0.08)',
    hover: 'rgba(177, 186, 196, 0.08)',
    text: '#9aa7b4',
    textActive: '#ffffff',
    textMuted: '#6e7b88',
  },
  palette: {
    blue: {
      '50': '#e8f4fa',
      '100': '#d1e9f5',
      '200': '#a3c6e8',
      '300': '#7baad6',
      '400': '#5788b5',
      '500': '#2f5c81',
      '600': '#255a80',
      '700': '#5a80ab',
      '800': '#1a4060',
      '900': '#0f2540',
    },
    darkGray: {
      '50': '#ccd4dd',
      '100': '#99a8bb',
      '200': '#8197ab',
      '300': '#536471',
      '400': '#3f4347',
      '500': '#0f1419',
      '600': '#0c1015',
      '700': '#090c10',
      '800': '#06080a',
      '900': '#030405',
    },
    gray: {
      '50': '#fafafa',
      '100': '#f5f5f5',
      '200': '#eeeeee',
      '300': '#e0e0e0',
      '400': '#bdbdbd',
      '500': '#969696',
      '600': '#757575',
      '700': '#616161',
      '800': '#424242',
      '900': '#212121',
    },
    green: {
      '50': '#e3f2e4',
      '100': '#c8e6c9',
      '200': '#a5d6a7',
      '300': '#81c784',
      '400': '#66bb6a',
      '500': '#4caf50',
      '600': '#16aa16',
      '700': '#138813',
      '800': '#0f660f',
      '900': '#0a440a',
    },
    orange: {
      '50': '#fff0d9',
      '100': '#ffe0b2',
      '200': '#ffcc80',
      '300': '#ffb74d',
      '400': '#ffa726',
      '500': '#ff9800',
      '600': '#fb8c00',
      '700': '#f57c00',
      '800': '#ef6c00',
      '900': '#e65100',
    },
    red: {
      '50': '#f7cdcd',
      '100': '#ef9a9a',
      '200': '#e57373',
      '300': '#ef5350',
      '400': '#f44336',
      '500': '#dc0d16',
      '600': '#b00a12',
      '700': '#c00b0b',
      '800': '#900909',
      '900': '#600606',
    },
  },
};

export default colors;
